import { fallbackDefaults, imagePlacementDefaults, randomPlaceholderTitle } from './config';
import type { AspectId, AudioMeta, ImagePlacement, OutputState, PaletteId, QualityId, TemplateId, UploadedImage } from './types';

export type AppState = {
  audioFile: File | null;
  audioMeta: AudioMeta | null;
  image: UploadedImage | null;
  imagePlacement: ImagePlacement;
  output: OutputState | null;
  placeholderTitle: string;
  title: string;
  subtitle: string;
  aspect: AspectId;
  palette: PaletteId;
  quality: QualityId;
  template: TemplateId;
  titleWasEdited: boolean;
  isReadingAudio: boolean;
  isBusy: boolean;
};

export function createInitialState(): AppState {
  return {
    audioFile: null,
    audioMeta: null,
    image: null,
    imagePlacement: { ...imagePlacementDefaults, focalPoint: { ...imagePlacementDefaults.focalPoint } },
    output: null,
    placeholderTitle: randomPlaceholderTitle(),
    title: '',
    subtitle: '',
    aspect: fallbackDefaults.aspect,
    palette: 'signal',
    quality: fallbackDefaults.quality,
    template: fallbackDefaults.template,
    titleWasEdited: false,
    isReadingAudio: false,
    isBusy: false,
  };
}
